import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// ctm
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { PaymentFrequencyFilterDropdown } from '../../filters/common/payment_frequency_filter_dropdown';
import { DiscountOffer } from '../common/discount_offer';
import { ProductPrice } from '../common/product_price';
import { ProductPriceMonthlyNotice } from '../common/product_price_monthly_notice';

const useStyles = createUseStyles((theme) => ({
    container: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.primary50,
        borderRadius: theme.borderRadius.default,
        marginBottom: '1rem',
        paddingTop: theme.spacing[8],
        paddingBottom: theme.spacing[8]
    },
    dropdownContainer: {
        marginBottom: '-1.2rem'
    },
    dropdownButton: {
        fontSize: theme.fontSize.sm
    }
}));

const _ProductPriceCard = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { productAnnualPremium, productMonthlyPremium, productMonthlyFirstMonth, productAnnualisedMonthlyPremium,
        quote, className } = props;

    return (
        <div className={classNames('test-policyProductCard-priceCard', classes.container, className)}>
            <div className={classes.dropdownContainer}>
                <PaymentFrequencyFilterDropdown
                    className={classes.dropdownButton}
                    isWithoutLabel
                    options={{ annual: 'Annual cost', monthly: 'Monthly cost' }}
                />
            </div>
            <ProductPrice
                productAnnualPremium={productAnnualPremium}
                productMonthlyPremium={productMonthlyPremium}
            />
            <ProductPriceMonthlyNotice
                productMonthlyFirstMonth={productMonthlyFirstMonth}
                productAnnualisedMonthlyPremium={productAnnualisedMonthlyPremium}
            />
            <DiscountOffer quote={quote} />
        </div>
    );
};

_ProductPriceCard.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,

    productAnnualPremium: PropTypes.number,
    productMonthlyPremium: PropTypes.number,
    productMonthlyFirstMonth: PropTypes.number,
    productAnnualisedMonthlyPremium: PropTypes.number
};

const ProductPriceCard = withQuoteFlatten(_ProductPriceCard);

export { ProductPriceCard };
